var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup536(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_12",
    x: 0,
    y: 0,
    width: 174,
    height: 174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 84,
    height: 84,
    fill: "#03234a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(-873 -405)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 873, 405)",
    filter: "url(#Ellipse_12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12-2",
    "data-name": "Ellipse 12",
    transform: "translate(10 10)",
    fill: "#d0fb56",
    stroke: "#e8eff3",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 77,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 82,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535",
    transform: "translate(917.956 445.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535-2",
    "data-name": "Group 535",
    transform: "translate(0.044 0.044)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M7.021,84.247S0,84.247,0,77.227,7.021,49.144,42.124,49.144,84.247,70.206,84.247,77.227s-7.021,7.021-7.021,7.021Zm35.1-42.124A21.062,21.062,0,1,0,21.062,21.062,21.061,21.061,0,0,0,42.124,42.124",
    transform: "translate(-0.038 -0.209)",
    fill: "#03234a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup536);
export default __webpack_public_path__ + "static/media/Group 536.06db0836a10f1559845a6a4f287fa7ba.svg";
export { ForwardRef as ReactComponent };